@if (shouldShow$ | async) {
  <div class="fullscreen-overlay">
    <div class="content">
      <img
        ngSrc="assets/graphic-beta-enabled.svg"
        alt="Pre-registration successful"
        priority="priority"
        height="215"
        width="219" />
      <h4 class="text-white">Pre-registration successful!</h4>
      <p>
        Keep an eye on your inbox. We will reach out closer to Beta launch with final instructions and your access
        details soon.
      </p>
    </div>
  </div>
}
